import React, {Component} from 'react'
import CalendarEditForm from './components/CalendarEditFormComponent.jsx';
import SideBar from '../common/layout/sidebar.component.jsx'

class CalendarNew extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
        }
    }

    componentDidMount() {
        SideBar.activateMenu('sales-tools')
    }

    render() {
        return (
            <div>
                <CalendarEditForm />
            </div>
        );
    }
}

export default CalendarNew


// WEBPACK FOOTER //
// ./src/calendar/new.component.jsx